<template>

    <v-layout class="container-modal">
        <v-dialog :modelValue="dialog" @click:outside="closeModal()" max-width="800px"
            transition="dialog-bottom-transition">

            <v-card>
                <v-form>
                    <v-card-title class="p-3 header-modal mb-4">
                        <span class="headline text-white">{{ modal_title }}</span>
                    </v-card-title>
                    <v-card-text>
                        <div class="container-card-fee">
                            <div class="content-card-fee">
                                <div v-if="loading">
                                    <v-skeleton-loader v-for="n in 3" :key="n" class="skeleton-card-loader mb-2"
                                        type="card"></v-skeleton-loader>
                                </div>
                                <div v-else>
                                    <template
                                        v-if="listRates.some(zoneGroup => zoneGroup.price != null)">

                                        <div v-for="(zoneGroup) in listRates" :key="zoneGroup.id">
                                            <CardFee :zoneGroup="zoneGroup" :cardTitle="zoneGroup.zone_group.name"
                                                :basePrice="zoneGroup.zone_group.base_price" :isView="true"
                                                :isConfigure="true"></CardFee>
                                        </div>
                                    </template>
                                    <div v-else class="d-flex justify-content-center">
                                        <v-label class="text-component">El chofer no configuró sus zonas</v-label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <Button flat class="btn text-capitalize text-white me-1 btn-modal" type="button" rounded="xl"
                            height="50" text @click="closeModal()" label="Cerrar" color="error"></Button>


                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import Button from "@/components/Button.vue";
import { ratesService } from "@/libs/ws/Logistic/ratesService";
import CardFee from "@/components/CardFee.vue";

export default {
    mixins: [ValidMixin],
    components: { Button, CardFee },
    props: {
        service: Object,
        modal_title: String,
        page_title: String,
        formBtn: String,
        dialog: Boolean,
        updateDialog: Function,
        loadList: Function,
        editItem: Object,
        idriver_user_id: Number,
        idriver_id: Number
    },
    data() {
        return {
            show: false,
            disabled: false,
            loading: false,
            name: "",
            listRates: [],
            provincias: [],
            defaultItem: null,
        };
    },
    watch: {
        dialog() {
            if (this.dialog) {
                this.loadRates();
            }
        },
    },
    mounted() {
    },
    methods: {

        closeModal() {
            this.$emit("updateDialog", false);
            this.listRates = [];
        },
        loadRates() {
            this.loading = true;
            const param = {
                user_owner_id: this.idriver_user_id,
                idriver_id: this.idriver_id,
                list: "independent_driver"
            }

            ratesService
                .filter(param)
                .then((response) => {
                    this.listRates = response.result.list;
                })
                .catch((e) => {
                    console.log('e', e)
                })
                .finally(() => {
                    this.loading = false;
                });
        }

    },
};
</script>